import { createAsyncThunk } from "@reduxjs/toolkit";
import localhost from "apis/localhost";
import { showErrorModal } from "slices/app/actions/error";
import { addToJobQueue, removeFromJobQueue } from "slices/app/appSlice";

import { ERROR_TITLE } from "../constants";

export const fetchWatchwordsList = createAsyncThunk(
  "watchwords/list/fetchWatchwords",
  async (_, { dispatch }) => {
    dispatch(addToJobQueue("fetchWatchwords"));
    try {
      const rsp = await localhost.get("watchwords/list");
      return rsp.data;
    } catch (err) {
      dispatch(showErrorModal(err));
      return null;
    } finally {
      dispatch(removeFromJobQueue("fetchWatchwords"));
    }
  }
);

export const deleteWatchwordsListById = createAsyncThunk(
  "watchwords/list/deleteWatchwordListById",
  async (id, { dispatch }) => {
    dispatch(addToJobQueue("deleteWatchwordsList"));

    try {
      await localhost.delete(`watchwords/${id}`);
      return id;
    } catch (error) {
      dispatch(showErrorModal(error, ERROR_TITLE));
      return false;
    } finally {
      dispatch(removeFromJobQueue("deleteWatchwordsList"));
    }
  }
);
